export const UnitsOperationTypeEnum = {
  sale: {
    key: 430,
    value: 'sale',
    forValue: 'for-sale',
    color: 'c-success',
  },
  rent: {
    key: 431,
    value: 'rent',
    forValue: 'for-rent',
    color: 'c-secondary',
  },
  rentAndSale: {
    key: 20984,
    value: 'rent-and-sale',
    forValue: 'for-rent',
    color: 'c-secondary',
  },
};

export const LeadOperationTypeEnum = {
  buy: {
    key: 491,
    value: "buy",
    forValue: "for-sale",
    color: "c-success",
  },
  rent: {
    key: 492,
    value: "rent",
    forValue: "for-rent",
    color: "c-secondary",
  },
};

export const UnitsOperationType = {
  lookupTypeId: 29
};
